<div *ngIf="details !== undefined">

  <div class="content-wrapper">
    <div class="details">

      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.documentLongId' | translate }}</div>
          <div class="value">{{ details.documentLongId }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.type' | translate }}</div>
          <div class="value">{{ ((currentLanguage | async) === 'en' ? details.documentType?.english : details.documentType?.hebrew) || '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.mediaType' | translate }}</div>
          <div class="value">{{ ((currentLanguage | async) === 'en' ? details.mediaType?.english : details.mediaType?.hebrew) || '-' }}</div>
        </div>
      </div>

      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.folderLongId' | translate }}</div>
          <div class="value">
            <a *ngIf="canNavigateToFolder" class="custom-link" role="navigation" tabindex="0" (click)="onViewFolder(details.folderEntityId)" (keydown.enter)="onViewFolder(details.folderEntityId)">
              {{ details.folderLongId || '-' }}
            </a>
            <span *ngIf="!canNavigateToFolder">{{ details.folderLongId || '-' }}</span>
          </div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.docNumber' | translate }}</div>
          <div class="value">{{ details.docNumber || '-' }}</div>
        </div>
         <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.totalPages' | translate }}</div>
          <div class="value">{{ details.totalPages ?? '-' }}</div>
        </div>
      </div>

      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.document.boxId' | translate }}</div>
          <div class="value">{{ details.boxId ?? '-' }}</div>
        </div>
      </div>

      <div class="section-accordion">
        <app-accordion-panel [header]="'iaa.conservationArchive.folder.sites' | translate" [count]="hasSiteData ? 1 : 0" [disabled]="!hasSiteData" [selected]="hasSiteData" [currentLanguage]="currentLanguage">
          <div [ngClass]="{'accordion-row header fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}">
            <div>{{ 'iaa.conservationArchive.folder.relatedType' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.siteNumber' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.siteName' | translate }}</div>
          </div>
          <div [ngClass]="{'accordion-row fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}" *ngIf="hasSiteData">
              <div>{{ details.siteType || '-' }}</div>
              <div *ngIf="!canNavigateToSite">{{ details.siteId ? (details.siteId + (details.siteSubId && details.siteSubId !== 0 ? '/' + details.siteSubId : '')) : '-' }}</div>
              <a *ngIf="canNavigateToSite" class="custom-link" role="button" tabindex="0" (click)="onViewSite(details.siteEntityId)" (keydown.enter)="onViewSite(details.siteEntityId)">
                {{ details.siteId }}{{ details.siteSubId && details.siteSubId !== 0 ? '/' + details.siteSubId : '' }}
              </a>
              <a *ngIf="canNavigateToSite" class="custom-link" role="button" tabindex="0" (click)="onViewSite(details.siteEntityId)" (keydown.enter)="onViewSite(details.siteEntityId)">
                {{ details.siteName || '-' }}
              </a>
              <div *ngIf="!canNavigateToSite">{{ details.siteName || '-' }}</div>
            </div>
        </app-accordion-panel>
      </div>

      <div style="flex-grow: 1;"></div>
    </div>

    <div class="image-preview">
      <app-image-gallery
        [images]="images"
        [thumbnails]="thumbnails"
        [customError]="!details.hasScan ? 'iaa.conservationArchive.document.notScannedMessage' : null"
        class="gallery"
        [objectName]="('iaa.conservationArchive.document.objectName' | translate) + ' ' + (details.documentLongId || '')">
      </app-image-gallery>
    </div>
  </div>
</div>
